module.exports = __webpack_public_path__ + "static/one-percent-apply_bg-f2fe577bef04098b1c1bffcd17d52781.png";